// ConsentSection.jsx
import { useState } from "react";
import styles from "./ConsentSection.module.css";

const ConsentSection = ({ onNext }) => {
    const [accepted, setAccepted] = useState(false);

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <div className={styles.header}>
                    <h2 className={styles.title}>Section A: Study Consent</h2>
                    <p className={styles.description}>
                        Study Number: NIS/2025/33 | Version: 1.0
                    </p>
                </div>

                <div className={styles.content}>
                    <div className={styles.infoBox}>
                        <div className={styles.section}>
                            <h3 className={styles.sectionTitle}>Study Title</h3>
                            <p className={styles.sectionText}>
                                A Questionnaire Based Study On Current Trends And Clinical Decision Drivers In The Topical Management Of Tinea Infections - Cross-Sectional Study
                                <br/>
                                As a participating investigator in the above-mentioned Post-Marketing Observational Study, I understand and agree to the following:
                            </p>
                        </div>

                        <div className={styles.section}>
                            <h4 className={styles.subheading}>Study Conduct</h4>
                            <p className={styles.subtext}>
                                I have read, understood the study protocol and agree to conduct the study in accordance with the applicable regulatory and ethical requirements.
                            </p>
                        </div>

                        <div className={styles.section}>
                            <h4 className={styles.subheading}>Data Entry and Source Documentation</h4>
                            <p className={styles.subtext}>
                                I will ensure that accurate, complete, and verifiable data is entered into the electronic Case Report Form (eCRF) for each subject.
                                <br/>
                                As required, I will upload source document such as prescriptions copy or laboratory reports or radiological reports or vital signs charts to confirm the existence of the patient and support data accuracy.
                            </p>
                        </div>

                        <div className={styles.section}>
                            <h4 className={styles.subheading}>Confidentiality and Data Protection</h4>
                            <p className={styles.subtext}>
                                From the uploaded source documents, all patient identifiers (e.g., name) will be masked at the CRO end by a dedicated and authorized personnel.
                                <br/>
                                Neither the Sponsor nor the CRO will have access to patient identifiers at any time and the same will be disclosed only upon formal request from authorized regulatory or ethics auditors, if required.
                            </p>
                        </div>

                         <div className={styles.section}>
                            <h4 className={styles.subheading}>Sponsor Responsibilities</h4>
                            <p className={styles.subtext}>
                                The Sponsor will ensure the confidentiality and protection of all subject records in accordance with applicable privacy laws and regulatory requirements.
                            </p>
                        </div>

                          <div className={styles.section}>                           
                            <p className={styles.subtext}>
                                By signing below, I acknowledge and accept my responsibilities and agree to participate in this Post-Marketing Observational Study as an investigator.
                            </p>
                        </div>
                    </div>

                    {/* <div className={styles.checkboxWrapper}>
                        <input
                            type="checkbox"
                            id="consent"
                            checked={accepted}
                            onChange={(e) => setAccepted(e.target.checked)}
                            className={styles.checkbox}
                        />
                        <label htmlFor="consent" className={styles.checkboxLabel}>
                            I have read and understood the study information. I voluntarily agree to participate
                            in this research study and understand that I can withdraw at any time.
                        </label>
                    </div> */}

                    <div className={styles.buttonWrapper}>
                        <button
                            onClick={onNext}
                            // disabled={!accepted}
                            className={styles.continueButton}
                        >
                            I Agree
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConsentSection;